import i18n from "../../../../constants/i18n";
import { SILENTLY_BANNED_USERS_HEADERS } from "../../../../constants/table-custom-headers/User";
import { withLiteObserverAndTheme } from "../../../../core/et3-enhanced-render";
import Et3Table from "../../../../core/et3-table";
import getSilentBannedUsersStore from "../../../../stores/user-store/silent-banned-store";

const SilentlyBannedUsersData = withLiteObserverAndTheme(() => {
  const silentBannedUsers = getSilentBannedUsersStore().silentBannedUsers.get();

  return (
    <Et3Table
      columns={SILENTLY_BANNED_USERS_HEADERS}
      rows={silentBannedUsers}
      title={i18n.get("SILENTLY_BANNED_USERS")}
      shouldBeFlagged={false}
      titleKey={"SILENTLY_BANNED_USERS"}
    />
  );
});
export default SilentlyBannedUsersData;
